"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfBracketMatchResource = instanceOfBracketMatchResource;
exports.BracketMatchResourceFromJSON = BracketMatchResourceFromJSON;
exports.BracketMatchResourceFromJSONTyped = BracketMatchResourceFromJSONTyped;
exports.BracketMatchResourceToJSON = BracketMatchResourceToJSON;
exports.BracketMatchResourceToJSONTyped = BracketMatchResourceToJSONTyped;
var RelToHrefs_1 = require("./RelToHrefs");
var WinCondition_1 = require("./WinCondition");
var MatchState_1 = require("./MatchState");
var IdResource_1 = require("./IdResource");
var Expanded_1 = require("./Expanded");
/**
 * Check if a given object implements the BracketMatchResource interface.
 */
function instanceOfBracketMatchResource(value) {
    return true;
}
function BracketMatchResourceFromJSON(json) {
    return BracketMatchResourceFromJSONTyped(json, false);
}
function BracketMatchResourceFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'bracket': json['bracket'] == null ? undefined : (0, IdResource_1.IdResourceFromJSON)(json['bracket']),
        'event': json['event'] == null ? undefined : (0, IdResource_1.IdResourceFromJSON)(json['event']),
        'externalId': json['externalId'] == null ? undefined : json['externalId'],
        'winCondition': json['winCondition'] == null ? undefined : (0, WinCondition_1.WinConditionFromJSON)(json['winCondition']),
        'winConditionAmount': json['winConditionAmount'] == null ? undefined : json['winConditionAmount'],
        'assignments': json['assignments'] == null ? undefined : (json['assignments'].map(IdResource_1.IdResourceFromJSON)),
        'startDate': json['startDate'] == null ? undefined : (new Date(json['startDate'])),
        'checkInBegins': json['checkInBegins'] == null ? undefined : (new Date(json['checkInBegins'])),
        'checkInDeadline': json['checkInDeadline'] == null ? undefined : (new Date(json['checkInDeadline'])),
        'state': json['state'] == null ? undefined : (0, MatchState_1.MatchStateFromJSON)(json['state']),
        'winner': json['winner'] == null ? undefined : (0, IdResource_1.IdResourceFromJSON)(json['winner']),
        'description': json['description'] == null ? undefined : json['description'],
        'round': json['round'] == null ? undefined : json['round'],
        'entryReportCompleted': json['entryReportCompleted'] == null ? undefined : json['entryReportCompleted'],
        'dateConflicted': json['dateConflicted'] == null ? undefined : (new Date(json['dateConflicted'])),
        'dateResolved': json['dateResolved'] == null ? undefined : (new Date(json['dateResolved'])),
        'dateDisputed': json['dateDisputed'] == null ? undefined : (new Date(json['dateDisputed'])),
        'negotiableUntil': json['negotiableUntil'] == null ? undefined : (new Date(json['negotiableUntil'])),
        'prerequisiteMatchIdsCsv': json['prerequisiteMatchIdsCsv'] == null ? undefined : json['prerequisiteMatchIdsCsv'],
        'identifier': json['identifier'] == null ? undefined : json['identifier'],
        'scoresCsv': json['scoresCsv'] == null ? undefined : json['scoresCsv'],
        'forfeit': json['forfeit'] == null ? undefined : json['forfeit'],
        'note': json['note'] == null ? undefined : (0, IdResource_1.IdResourceFromJSON)(json['note']),
        'activeChannel': json['activeChannel'] == null ? undefined : (0, IdResource_1.IdResourceFromJSON)(json['activeChannel']),
        'escalation': json['escalation'] == null ? undefined : (0, IdResource_1.IdResourceFromJSON)(json['escalation']),
        'games': json['games'] == null ? undefined : (json['games'].map(IdResource_1.IdResourceFromJSON)),
        '_expanded': json['_expanded'] == null ? undefined : (0, Expanded_1.ExpandedFromJSON)(json['_expanded']),
        '_links': json['_links'] == null ? undefined : (0, RelToHrefs_1.RelToHrefsFromJSON)(json['_links']),
    };
}
function BracketMatchResourceToJSON(json) {
    return BracketMatchResourceToJSONTyped(json, false);
}
function BracketMatchResourceToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'bracket': (0, IdResource_1.IdResourceToJSON)(value['bracket']),
        'event': (0, IdResource_1.IdResourceToJSON)(value['event']),
        'externalId': value['externalId'],
        'winCondition': (0, WinCondition_1.WinConditionToJSON)(value['winCondition']),
        'winConditionAmount': value['winConditionAmount'],
        'assignments': value['assignments'] == null ? undefined : (value['assignments'].map(IdResource_1.IdResourceToJSON)),
        'startDate': value['startDate'] == null ? undefined : ((value['startDate']).toISOString()),
        'checkInBegins': value['checkInBegins'] == null ? undefined : ((value['checkInBegins']).toISOString()),
        'checkInDeadline': value['checkInDeadline'] == null ? undefined : ((value['checkInDeadline']).toISOString()),
        'state': (0, MatchState_1.MatchStateToJSON)(value['state']),
        'winner': (0, IdResource_1.IdResourceToJSON)(value['winner']),
        'description': value['description'],
        'round': value['round'],
        'entryReportCompleted': value['entryReportCompleted'],
        'dateConflicted': value['dateConflicted'] == null ? undefined : ((value['dateConflicted']).toISOString()),
        'dateResolved': value['dateResolved'] == null ? undefined : ((value['dateResolved']).toISOString()),
        'dateDisputed': value['dateDisputed'] == null ? undefined : ((value['dateDisputed']).toISOString()),
        'negotiableUntil': value['negotiableUntil'] == null ? undefined : ((value['negotiableUntil']).toISOString()),
        'prerequisiteMatchIdsCsv': value['prerequisiteMatchIdsCsv'],
        'identifier': value['identifier'],
        'scoresCsv': value['scoresCsv'],
        'forfeit': value['forfeit'],
        'note': (0, IdResource_1.IdResourceToJSON)(value['note']),
        'activeChannel': (0, IdResource_1.IdResourceToJSON)(value['activeChannel']),
        'escalation': (0, IdResource_1.IdResourceToJSON)(value['escalation']),
        'games': value['games'] == null ? undefined : (value['games'].map(IdResource_1.IdResourceToJSON)),
        '_expanded': (0, Expanded_1.ExpandedToJSON)(value['_expanded']),
        '_links': (0, RelToHrefs_1.RelToHrefsToJSON)(value['_links']),
    };
}
